import { Component, Input, OnInit } from '@angular/core';
import { SharedService } from '@app/core';

@Component({
  selector: 'app-plan-expiry-banner',
  templateUrl: './plan-expiry-banner.component.html',
  styleUrls: ['./plan-expiry-banner.component.scss']
})
export class PlanExpiryBannerComponent implements OnInit {
  @Input() bannerMessage: string = '';
  @Input() buttonShow: boolean = true;

  constructor(private readonly sharedService: SharedService) { }

  ngOnInit(): void {
  }

  onOpenSubscriptionModal() {
    this.sharedService.isPremiumUser.next(true);
  }

}
